"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireDefault(require("react"));

var _UIStepperButton = _interopRequireDefault(require("./UIStepperButton"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var EXCLUDED_STEPPER_BUTTON_PROP_NAMES = ['iconName', 'aria-label'];

var UIPreviousButton = _react.default.createClass({
  displayName: "UIPreviousButton",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIStepperButton.default.propTypes, EXCLUDED_STEPPER_BUTTON_PROP_NAMES)),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, (0, _omit.default)(_UIStepperButton.default.defaultProps, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
  },
  render: function render() {
    var _this$props = this.props,
        __iconName = _this$props.iconName,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["iconName"]);
    return _react.default.createElement(_UIStepperButton.default, (0, _extends2.default)({
      "aria-label": _I18n.default.text('salesUI.UIPreviousButton.label'),
      iconName: "previous"
    }, rest));
  }
});

var _default = UIPreviousButton;
exports.default = _default;
module.exports = exports.default;